export interface UrlFilter {
  slug: string
  values: string[]
}

// export const getPillsData = (
//   urlFilters: UrlFilter[],
//   attributeFiltersData: AttributeFilterFragment[]
// ): FilterPill[] =>
//   urlFilters.reduce((result: FilterPill[], filter: UrlFilter) => {
//     const choiceAttribute = attributeFiltersData.find(
//       (attr) => attr.slug === filter.slug
//     )
//     const attrName = choiceAttribute ? choiceAttribute.name : filter.slug
//     const newPills = filter.values.map((value) => {
//       const attrChoice = choiceAttribute?.choices?.edges.find(
//         (choice) => choice.node.slug === value
//       )
//       const choiceName = attrChoice?.node.name || value
//       return {
//         label: `${attrName}: ${choiceName}`,
//         choiceSlug: value,
//         attributeSlug: filter.slug,
//       }
//     })
//     return [...result, ...newPills]
//   }, [])

// export const getPillsData = (
//   urlFilters: UrlFilter[],
//   attributeFiltersData: AttributeFilterFragment[]
// ): FilterPill[] =>
//   urlFilters.reduce((result: FilterPill[], filter: UrlFilter) => {
//     const choiceAttribute = attributeFiltersData.find((attr) => attr.slug === filter.slug);
//     const attrName = choiceAttribute ? choiceAttribute.name : filter.slug;
//     const newPills = filter.values.map((value) => {
//       const attrChoice = choiceAttribute?.choices?.edges.find(
//         (choice) => choice.node.slug === value
//       );
//       const choiceName = attrChoice?.node.name || value;
//       return {
//         label: attrName ? `${attrName}: ${choiceName}` : choiceName,
//         choiceSlug: value,
//         attributeSlug: filter.slug,
//       };
//     });
//     return [...result, ...newPills];
//   }, []);

export const parseQueryAttributeFilters = (query: string): UrlFilter[] => {
  const filters: UrlFilter[] = []
  query.split(';').map((attributeWithValues) => {
    const splitted = attributeWithValues.split('.')
    const attributeFilter = { slug: splitted[0], values: splitted.slice(1) }
    if (attributeFilter.values.length > 0) {
      filters.push(attributeFilter)
    }
  })
  return filters
}

export const serializeQueryAttributeFilters = (values: UrlFilter[]): string =>
  values.map((value) => [value.slug, ...value.values].join('.')).join(';')

export const getLabel = (value: string) =>
  value
    ?.substring(value.indexOf('_') + 1)
    .charAt(0)
    .toUpperCase() + value?.substring(value.indexOf('_') + 1).slice(1)
// export const serializeQueryAttributeFilters = (values: UrlFilter[]): string =>
//   values.map((value) => [value.slug, ...value.values].join('.')).join(';')
//d
